import { useEffect, useState } from "react";
import Config from "../../Config";
import AppContext from "../../AppContext";
import InputComboRok from "../../helpers/InputComboRok";
import InputComboMiesiac from "../../helpers/InputComboMiesiac";
import back from "../../back.png";
import InputDate from "../../helpers/InputDate";


function Export(props)
{
 
    const raportList = [
        {  name: "JPK VAT", uq: '000000001', format: '.csv' },
        {  name: "JPK FA", uq: '000000002',  format: '.csv' },
    ];

    const [resultStream , setResultStream] = useState(null);

    const [refreshView, setRefreshView] = useState(props.userData.refreshView);

    const [view, setView] = useState (  {v:'list', id: -1, uq: ''} );
    
    const [filterParam, setFilterParam] = useState({   
            
        rok:  props.mainView.readFilter('rok','_x_'),    
        miesiac:  props.mainView.readFilter('miesiac','_x_'),    

        data_od:  props.mainView.readFilter('data_od',''),    
        data_do:  props.mainView.readFilter('data_do',''),    
          
    });


        const valChangeListener = (filedName, val, correct, msg) => {

            //console.log("valChangeListener: " + filedName + " " + val + ", correct: " + correct + ", msg: " + msg);
            setFilterParam( {...filterParam, [filedName]:val,  [filedName+"_valid"]:correct } );                                  
            if(   (val.length == 0 || val.length > 2 || msg =='combo')  && filterParam[filedName] != val )
            {
                    var defTimeOut = 500;
                    if(msg == 'combo') defTimeOut = 10;
                    clearTimeout(AppContext.timeoutId);
                    AppContext.timeoutId = setTimeout( () => {
                       // setTab(null); 
                    } , defTimeOut );
            }
        
            props.mainView.writeFilter(filedName, val);            
    }


  const changeView = (e ) => {
            var v = e.target.getAttribute('v');
            var id = e.target.getAttribute('id');
            var uq = e.target.getAttribute('uq');

            setView({...view, ["v"]:v, ["id"]:id, ["uq"]:uq });
    }


    const onBack = ( ) => {                
        setView({...view, ["v"]:"list", ["id"]:-1, ["uq"]:''  });               
    }

   
   const onSuccess = ( ) => {                
        setView({...view, ["v"]:"list", ["id"]:-1, ["uq"]:'' });       
       
    }

    
    
     const getRaport = () => {
        
      
       props.mainView.showProgress();

       filterParam['uq'] = view.uq;

        fetch( Config.url + '/rest_v1_rap,export', {
            method: 'POST', 
            body: JSON.stringify(filterParam), 
            headers: {
                'Content-Type': 'application/json',                    
                'X-Api-Key': props.userData.apiKey,
                '_fak_sprzedawcy_id_': props.userData.fak_sprzedawcy_id,   
                '_sec_key_': Config.genXKey() ,
            }
         })
         .then(res => res.json() )
         .then(res => { 

                    props.mainView.hideProgress();

                    if(res._sys_ == undefined)
                    {
                        props.mainView.showDialog( "Ups!", "No correct response from server.." , "error" , null);  
                    }else
                    if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                    {
                        props.mainView.showDialog( "Ups!", JSON.stringify(res.result) , "error" , null);  
                    }else    
                    {
                       // setTab(res.result);               
                       setResultStream(res.result); 
                    }
         } )
         .catch(err => {          
                    props.mainView.showDialog( "Ups!", "I: " + err , "error" , null);
                    props.mainView.hideProgress();
         });
                   

         return false;
    }


    const resetStream = () => {
        setResultStream(null);
    }




    const keyListener = (e) => {
        
                                var code = e.keyCode ? e.keyCode : e.which;    
                                console.log("keylockd", e.target.nodeName, code );

                                if(e.target.nodeName.toLowerCase() != "body" && code == 27 )                                                  
                                {
                                    e.target.blur();
                                }else 
                                if(e.target.nodeName.toLowerCase() == "body" && code == 27 )                                                  
                                {                                                                
                                } else
                                if(e.target.nodeName.toLowerCase() == "body" && code == 8 )                                                  
                                {
                                        onBack();                               
                                } else 
                                {
                                    props.keyListener(e);
                                }
    }


    useEffect( ()=>{

            if(Config.env == "dev") console.log("Export.js, listener on");
            window.onkeydown = keyListener;   
                    
            
            return () => {   
                 if(Config.env == "dev") console.log("Export.js, listener off");             
                 window.onkeydown = props.keyListener;
            };

    } );







    if(refreshView != props.userData.refreshView)
    {
        setRefreshView( props.userData.refreshView);
        setView({...view, ["v"]:"list", ["id"]:-1, ["uq"]:'' });                 
    }



    var title = "";
    var dialogDownload = null;




    if(resultStream != null)
    {
         
          dialogDownload =  <div className="dlg_window shadowx " >

                        <div className="dlg_title" >Pobierz plik</div>
                        <div className="dlg_msg" >

                        <div>
                             <a href={"data:;base64," + resultStream.b64} download={ "download." + resultStream.typ } className="link_color"  >otwórz plik</a>
                        </div>
                        
                        </div>
                                <div className="dlg_btn">
                                    <div className="btn" onClick={resetStream} >zamknij [esc]</div>                             
                        </div>
        </div>
    }




    for(var k=0; k< raportList.length; k++)
    {
        if(raportList[k].uq == view.uq) title = raportList[k].name;
    }

    
    if(  view.v == "form" &&  (view.uq == "000000001" || view.uq == "000000002"  )   )
    {
        return <div className="view_content">
                       <img src={back} onClick={onBack} className="back_img" title="wstecz"/>
                       <h3 className="dash_header">{title}</h3>


                               <div className="table_filter">

                                         <div className="filter_controll filter_merge">   
                                                    <label>Okres (od dnia / do dnia): </label>      <br/>                       
                                                    <InputDate   userData={props.userData} value={filterParam.data_od}   valChange={valChangeListener} goNext={null} name="data_od" placeholder={"Od dnia: "}   />                                                                  
                                                    <InputDate   userData={props.userData} value={filterParam.data_do}   valChange={valChangeListener} goNext={null} name="data_do" placeholder={"Do dnia: "}   />
                                        </div> 

                                          <div className="filter_btn">                       
                                             <span className="btn" onClick={getRaport} >pobierz</span>
                                        </div> 

                               </div>
            {dialogDownload}                               
        </div>
    }

 


    return <div className="view_content">

               <h3 className="dash_header">Lista dostępnych raportów</h3>

                <div className="client_info">  
                     <ul>
                         {
                            raportList.map( (item, ix) => {

                                    return <li className="link_green"  v="form" id="-1" uq={item.uq} onClick={changeView}  >{item.name} ({item.format})</li>

                            } )
                         }
                     </ul>
                </div>

    </div>
}


export default Export;